import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import AppButton from "../../common/AppButton";
import AppErrorMessage from "../../common/AppErrorMessage";
import LoadingSpinner from "../../common/Loading";

interface IProps {
  handleResetPassword: any;
  handleChange: any;
  handleKeyDown: any;
  value: any;
  otp: any;
  getOtpAsString: any;
  handleContinue: any;
  otpError: any;
}
const OtpScreenLogin = ({
  handleResetPassword,
  handleChange,
  handleKeyDown,
  value,
  otp,
  getOtpAsString,
  handleContinue,
  otpError,
}: IProps) => {
  const { isLoading, isLoginError, loginMessage } = useAppSelector(
    (state: any) => state?.auth
  );
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery("(max-width: 1022px)");
  const [timer, setTimer] = useState(90);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (isResendDisabled && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setIsResendDisabled(false);
    }
  }, [timer, isResendDisabled]);

  const handleResendCode = () => {
    setIsResendDisabled(true);
    setTimer(90);
    handleContinue(); // Call your resend function here
  };

  return (
    <>
      <Box>
        <Box sx={{ textAlign: "center", fontSize: "24px", fontWeight: 500 }}>
          Verify
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 400,
            mb: 4.5,
            mt: 2,
          }}
        >
          Please enter the code we sent to you
        </Box>
        <Grid container spacing={2} justifyContent="center">
          {otp?.map((value: any, index: any) => (
            <Grid item key={index}>
              <TextField
                id={`otp-input-${index}`} // Assign unique ID to each input
                variant="outlined"
                value={value}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    width: "30px",
                    borderRadius: "5px",
                    border: "1px solid #004A9B",
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{
            textAlign: "center",
            fontSize: "14px",
            color: "#C4C4C4",
            mt: 2,
          }}
        >
          Didn't Receive the Code?
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: 500,
            cursor: isResendDisabled ? "not-allowed" : "pointer",
            color: isResendDisabled ? "#C4C4C4" : "#000000",
          }}
          onClick={!isResendDisabled ? handleResendCode : undefined}
        >
          {/* Resend Code */}
          {isResendDisabled ? `Resend Code after ${timer}s` : "Resend Code"}
        </Box>

        <Box sx={{ mt: 2 }}>
          {otpError && <AppErrorMessage message={otpError} />}
        </Box>
        <AppButton
          title="Verify Code"
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
          onClick={() => handleResetPassword(getOtpAsString())}
        />
      </Box>
    </>
  );
};

export default OtpScreenLogin;
